import { LanguageContext } from "App";
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Tooltip from "@mui/material/Tooltip";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import colors from "assets/theme/base/colors";
import typography from "assets/theme/base/typography";
import AsyncSelect from 'react-select/async';
import { useEffect, useState, useContext } from "react";
import TypesApi from '../../../../../Classes/API/UsersApi';
import SearchEmployeeTypes from '../../../../../Classes/Models/Requests/Administration/Employees/SearchEmployeeTypes';
import AddEmployeeToTypeReq from '../../../../../Classes/Models/Requests/AddManyToManyReq';
import AddManyToManyReq from "../../../../../Classes/Models/Requests/AddManyToManyReq";
import AppointmentsApi from "../../../../../Classes/API/Appointments/AppointmentsApi";
import Swal from "sweetalert2";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import SessionsApi from "Classes/API/Administration/SessionsApi";
import HistoryEntryUpdates from "layouts/AccountingSessions/AccountingSessionDetails/PatientHistory";
import UsersApi from "../../../../../Classes/API/UsersApi";
const PatientInfoCard = ({ User, GetUserData, shadow }) => {
    const {translations, switchLanguage} = useContext(LanguageContext)
    const Patient = User.getPatient;


    const [lastEvalReminder, setLastEvalReminder] = useState(Patient.lastEvalReminder);
    

    const ResetLastEvalReminder = async () => {
        Swal.fire({
            icon: 'info',
            title: 'Setting Last Eval Reminder',
            text: 'Please wait...',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            onBeforeOpen: () => {
                Swal.showLoading()
            },
        });

        let req = new AddManyToManyReq();
        req.Id1 = Patient.id;
        req.Id2 = lastEvalReminder;
        let res = await AppointmentsApi.SetLastEvalReminder(req);
        if (res.status == "Success") {
            Swal.fire({
                icon: 'success',
                title: 'Success',
                text: 'Last Eval Reminder has been reset',
                allowOutsideClick: true,
                allowEscapeKey: true,
                didOpen: () => {
                    Swal.hideLoading();
                }
            });
            GetUserData(User.id);
        }
        else {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'An error occured while resetting the Last Eval Reminder',
                allowOutsideClick: true,
                allowEscapeKey: true,
                didOpen: () => {
                    Swal.hideLoading();
                }
            });
        }
    }


    return (
        <Card sx={{ height: "100%", boxShadow: !shadow && "none" }}>
            <MDBox display="flex" justifyContent="space-between" alignItems="left" pt={2} px={2}>
                <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                  {translations.userManagementInfoUserPatientInfo}
                </MDTypography>
                {/* <MDTypography   variant="body2" color="secondary">
          <Tooltip   placement="top">
            <Icon>edit</Icon>
          </Tooltip>
        </MDTypography> */}
            </MDBox>
            <MDBox p={2}>

                <MDBox>
                    <MDBox display="flex" py={1} pr={2}>
                        <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                           {translations.userManagementInfoUserPatientInfoPatientId}: &nbsp;
                        </MDTypography>
                        <MDTypography variant="button" fontWeight="regular" color="text">
                            &nbsp;{Patient.id}
                        </MDTypography>
                    </MDBox>

                    <MDBox display="flex" py={1} pr={2}>
                        <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                            {translations.userManagementInfoUserPatientInfLastEvalReminder}: &nbsp; {Patient.lastEvalReminder}
                        </MDTypography>
                    </MDBox>
                    <MDBox display="flex" py={1} pr={2}>
                        <MDInput label={translations.userManagementInfoUserPatientInfResetLastEvalReminder} type="number"  defaultValue={Patient.lastEvalReminder} onChange={(e) => setLastEvalReminder(e.target.value)} />
                        <MDButton onClick={ResetLastEvalReminder}>{translations.userManagementInfoUserPatientInfReset}</MDButton>
                    </MDBox>

                </MDBox>
            </MDBox>
            {/* <HistoryEntryUpdates PatientId={Patient.id} PatientHistoryEntries={[]} CurrentUser={User} /> */}
        </Card>
    );
}

// Setting default props for the ProfileInfoCard
PatientInfoCard.defaultProps = {
    shadow: true,
};

// Typechecking props for the ProfileInfoCard
PatientInfoCard.propTypes = {

    shadow: PropTypes.bool,
};

export default PatientInfoCard
